import FooterBar from './footer-bar'
export default FooterBar
